<!--
 * @Desc: 业务员主页
 * @Author: may.li
 * @Date: 2023-03-08 17:59:38
 * @LastEditors: may.li
 * @LastEditTime: 2023-03-16 16:11:49
-->
<template>
	<div class="page_shopCenter page_agent">
		<div class="userInfo">
			<div class="user">
				<div class="user_top">
					<div class="user_left">
						<div class="thumb">
							<van-image class="thumb" :src="userThumb ? ($publicData.withHttpStart(userThumb) ? userThumb : imageUrl+userThumb) : $publicData.defaultTouxiang" fit="cover" :show-loading="false" :show-error="false" />
						</div>
						<div class="user_name slh_s">{{ userName }}</div>
					</div>
				</div>
			</div>
		</div>
		<ul class="agent_list">
			<li class="item" @click="routeLink('/salesman/agent',{'status': ableStatus,'first_agent_uuid': first_agent_uuid})">
				<div class="item_l member">
					<img :src="publicPath+'statics/images/icon_member.png'" alt="" class="icon">
					<span class="">二级分销商管理</span>
				</div>
			</li>
			<li class="item" @click="routeLink('/salesman/saomalog')">
				<div class="item_l tixianlist">
					<img :src="publicPath+'statics/images/icon_tixianlist.png'" alt="" class="icon">
					<span class="">扫码记录</span>
				</div>
			</li>
		</ul>
	</div>
</template>
<script>
export default {
	data(){
		return{
			token: null,
			publicPath: process.env.BASE_URL,
			userName: null,
			userThumb: null,
			ableStatus: null, // 1正常 2禁用
			first_agent_uuid: null,
			imageUrl: this.$publicData.uploadImage
		}
	},
	created(){
		this.token = this.$store.getters.token;
		this.getData();
	},
	methods: {
		/**
		 * @name: 获取业务员信息
		 * @return {*}
		 * @desc: 
		 */		
		getData(){
			let params = {
				token: this.token
			};
			this.$api.salesman.info(params).then(res=>{
				if(res.code == 200){
					let info = res.result;
					this.userName = info.name;
					this.userThumb = info.thumb;
					this.ableStatus = info.status;
					this.first_agent_uuid = info.first_agent_uuid;
				}else{
					this.$toast(res.message);
				}
			})
		},
		/**
		 * @name: 路由跳转
		 * @param {*} path
		 * @param {*} obj
		 * @return {*}
		 * @desc: 
		 */		
		routeLink(path,obj){
			this.$router.push({
				path: path,
				query: obj
			})
		}
	},
}
</script>
<style scoped>
	.page_agent .agent_list .item.hasno-right::after{
		display: none;
	}
</style>